import React from 'react';
import { x, styled } from '@xstyled/styled-components';
import PlusIcon from '~/assets/icons/plus.svg';

interface AddCardOutlineProps {
  width?: string;
  height?: string;
  text: string;
  onClick: () => void;
  disabled?: boolean;
  title?: string;
  backgroundColor?: string;
}

const Outline = styled.div<{
  width: string;
  height: string;
  disabled: boolean;
  backgroundColor?: string;
}>`
  width: ${p => p.width};
  height: ${p => p.height};
  min-width: 200px;
  min-height: 160px;
  border: 2px dashed ${p => (p.disabled ? '#cccccc' : '#9738ff')};
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: transparent;
  color: ${p => (p.disabled ? '#cccccc' : '#4a4a55')};
  font-weight: 600;
  font-size: 16px;
  gap: 8px;
  text-align: center;
  cursor: ${p => (p.disabled ? 'not-allowed' : 'pointer')};
  transition: all 0.2s ease;
  opacity: ${p => (p.disabled ? '0.5' : '1')};

  &:hover {
    border-color: ${p => (p.disabled ? '#cccccc' : '#7a2acc')};
    color: ${p => (p.disabled ? '#cccccc' : '#7a2acc')};
  }

  svg {
    width: 18px;
    height: 18px;
  }
  ${p => p.backgroundColor && `background: ${p.backgroundColor};`}
`;

export const AddCardOutline: React.FC<AddCardOutlineProps> = ({
  width = '295.67px',
  height = '270px',
  text,
  onClick,
  disabled = false,
  title,
  backgroundColor
}) => {
  const handleClick = () => {
    if (!disabled) {
      onClick();
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (!disabled && (e.key === 'Enter' || e.key === ' ')) {
      e.preventDefault();
      onClick();
    }
  };

  return (
    <Outline
      width={width}
      height={height}
      disabled={disabled}
      role="button"
      aria-label={text}
      aria-disabled={disabled}
      tabIndex={disabled ? -1 : 0}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      title={title}
      backgroundColor={backgroundColor}
    >
      <PlusIcon width={18} height={18} />
      <x.span>{text}</x.span>
    </Outline>
  );
};
